import getFetchOptions from 'utils/getFetchOptions';

import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';

export default function logout(hasSeenNotification) {
	return fetch(
		`${ENDPOINT_URL}/logout`,
		getFetchOptions({
			method: 'POST',
			body: JSON.stringify({hasSeenNotification}),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}

			localStorage.removeItem('authtoken');
			window.location.href = `/login`;
			return true;
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
